import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { overflow, position } from 'styled-system';
import { ReactComponent as CloseIcon } from '../../assets/icons/close_white.svg';

Modal.setAppElement('#root');

function ModalComponent({
  styles,
  children,
  modalIsOpen,
  closeThisModal,
  width
}) {
  const customStyles = {
    position: 'relative',
    overlay: {
      backgroundColor: 'rgba(49, 56, 62, 0.44)',
      zIndex: '500'
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: width || '100%',
      overflow: 'auto',
      maxHeight: '100%',
      height: 'fit-content'
    }
  };
  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeThisModal}
        htmlOpenClassName="ReactModal__Html--open"
        style={styles || customStyles}
      >
        <div>
          <button
            type="button"
            onClick={closeThisModal}
            style={{
              position: 'absolute',
              right: '10px',
              top: '10px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <CloseIcon />
          </button>
        </div>
        {children}
      </Modal>
    </>
  );
}

ModalComponent.propTypes = {
  styles: PropTypes.object.isRequired,
  children: PropTypes.any,
  closeThisModal: PropTypes.func,
  modalIsOpen: PropTypes.bool
};

export default ModalComponent;
